import React from 'react';
import './Appointment.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { AiFillHome } from 'react-icons/ai';
import ContactForm from '../../components/ContactForm/ContactForm';

const Appointment = () => {
    return (
        <section className='appointment-section pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row align-items-center">
                    {/* Left column for maps */}
                    <div className="col-lg-5 col-md-12">
                        <div className="google-map mb-4">
                            <iframe
                                title='map-1'
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56148.72704762909!2d77.24469024863282!3d28.410340899999987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cdf818c27a779%3A0x800902ff9d055091!2sDr.%20TANWAR%20DENTAL%20CLINIC%7CBest%20Dentist%20in%20Faridabad%7C%20Endodontist(%20ROOT%20CANAL%20specialist)%26%20Orthodontist(%20BRACES%20ALIGNERS%20sp)!5e0!3m2!1sen!2sin!4v1743653219310!5m2!1sen!2sin"
                                width="100%"
                                height="250"
                                style={{ border: 0 }}
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                            <div className="location-name">
                                <AiFillHome />
                                <p>Dr. Tanwar Dental Clinic – Sector 16</p>
                            </div>
                        </div>

                        <div className="google-map">
                        <iframe
                                title="map-2"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.310548269685!2d77.3427478!3d28.409884899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cdd0000deece7%3A0x8efae59de261136!2sDr%20TANWAR%20DENTAL%20EXPERT%20%7C%20best%20dental%20clinic%20in%20faridabad%7C!5e0!3m2!1sen!2sin!4v1761106108052!5m2!1sen!2sin"
                                width="100%"
                                height="250"
                                style={{ border: 0 }}
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                           
                            <div className="location-name">
                                <AiFillHome />
                                <p>Dr. Tanwar Dental Clinic – Sector 86</p>
                            </div>
                        </div>
                    </div>

                    {/* Right column for form and description */}
                    <div className="col-lg-7 col-md-12">
                        <div className="appointment-form-area">
                            <SectionTitle
                                subTitle="BOOK APPOINTMENT"
                                title=" Dr. Tanwar Dental - Experienced Dentist and Endodontist"
                                description="Dr. Bhagat S. Tanwar is a Dentist and Endodontist with 14 years of experience. He specializes in Conservative Dentistry & Endodontics and practices at Dr. Tanwar Dental Clinics in Sector 16 & Sector 86, Faridabad. BDS, MDS - Conservative Dentistry & Endodontics."
                            />
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Appointment;
